import React, { Component, Fragment } from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Checkbox, Select, Tabs } from 'antd';
import _ from 'lodash';
import { getCascadeComponents } from '../../../../services/Cascade/helper/setupData';
import NetsConnection from '../../components/netsConnection';
import { IMPEDANCE_INTERPOSER_LAYOUT } from '../../../../services/Cascade/constants';

class AddConnection extends Component {

  constructor() {
    super();
    this.state = {
      connectorList: {},
      activeKey: '0',
      autoConnection: []
    }
  }

  saveConnectorInfo(key, value, refresh) {
    const { index } = this.props;
    this.props.saveConnectorInfo(index, key, value, refresh);
  }

  componentDidUpdate = async (prevProps) => {
    const { connector, disabledName, designId, asPassiveBoard } = this.props;
    if (!_.isEqual(connector, prevProps.connector)) {
      this.setConnectorList(connector.netShip || [])
      if (disabledName) {
        if (designId && this.props.getAutoConnectionNet) {
          const connectionNets = await this.props.getAutoConnectionNet(designId, connector.name, this.hasPassive());
          this.setState({
            autoConnection: connectionNets
          })
        }
      }
    }
    if (asPassiveBoard !== prevProps.asPassiveBoard) {
      this.updateConnector()
    }
  }

  setConnectorList = async (netShip) => {
    const list = {};
    const { connectorList } = this.state;
    for (let ship of netShip) {
      if (!ship.designId || connectorList[ship.designId]) {
        continue;
      }
      const connectors = await this.props.getConnectionComps(ship.designId);
      list[ship.designId] = connectors
    }
    this.setState({
      connectorList: {
        ...connectorList,
        ...list
      }
    }, () => {
      this.props.resize()
    })
  }

  PCBSelect = async (value, index) => {
    const { connector } = this.props;
    let netShip = connector.netShip;
    netShip[index].designId = value;
    netShip[index].connector = "";
    netShip[index].nets = [];
    this.saveConnectorInfo('netShip', netShip);
    const { connectorList } = this.state;
    if (!connectorList[value] && value) {
      const connectors = await this.props.getConnectionComps(value);
      this.setState({
        connectorList: {
          ...connectorList,
          [value]: connectors
        }
      })
    }
  }

  setInterposer = (e, index) => {
    const { connector } = this.props;
    let netShip = connector.netShip;
    const value = e.target.checked
    netShip[index].asInterposer = value;
    if (value) {
      netShip[index].asPassiveBoard = false
      this.netsRef.clearNetsInfo();
    }
    this.saveConnectorInfo('netShip', netShip);
  }

  setPassiveBoard = async (e, index) => {
    const { connector, designId } = this.props;
    let netShip = connector.netShip;
    const value = e.target.checked
    netShip[index].asPassiveBoard = value;
    netShip[index].nets = [];
    if (designId && this.props.getAutoConnectionNet) {
      const connectionNets = await this.props.getAutoConnectionNet(designId, connector.name, value);
      this.setState({
        autoConnection: connectionNets
      })
    }
    if (value) {
      netShip[index].asInterposer = false
      this.netsRef.clearNetsInfo();
    }
    this.saveConnectorInfo('netShip', netShip);
  }

  connectorSelect = async (value, index) => {
    const { connector } = this.props;
    let netShip = connector.netShip;
    netShip[index].connector = value;
    netShip[index].nets = [];
    this.netsRef && this.netsRef.removeAllLines();
    if (!this.state.autoConnection.length && netShip[index].designId && netShip[index].connector) {
      const connectionNets = await this.props.getAutoConnectionNet(netShip[index].designId, netShip[index].connector, this.hasPassive());
      this.setState({
        autoConnection: connectionNets
      })
    }
    this.saveConnectorInfo('netShip', netShip, true);
  }

  updateConnector = async () => {
    const { connector } = this.props;
    const { activeKey } = this.state
    let netShip = connector.netShip || [];
    if (!netShip[activeKey]) {
      return
    }
    netShip[activeKey].nets = [];
    this.netsRef && this.netsRef.removeAllLines();
    if (netShip[activeKey].designId && netShip[activeKey].connector) {
      const connectionNets = await this.props.getAutoConnectionNet(netShip[activeKey].designId, netShip[activeKey].connector, this.hasPassive());
      this.setState({
        autoConnection: connectionNets
      })
    }
    this.saveConnectorInfo('netShip', netShip, true);
  }

  saveName = async (key, value) => {
    this.saveConnectorInfo(key, value);
    const { connector: { netShip = [] }, designId } = this.props;
    let _netShip = [...netShip];
    _netShip.forEach(ship => ship.nets = []);
    this.netsRef && this.netsRef.removeAllLines()
    this.saveConnectorInfo('netShip', _netShip, true);
    if (designId && this.props.getAutoConnectionNet) {
      const connectionNets = await this.props.getAutoConnectionNet(designId, value, this.hasPassive());
      this.setState({
        autoConnection: connectionNets
      })
    }
  }

  saveNets = () => {
    if (this.netsRef) {
      const { nets, save, netsInfo } = this.netsRef.getNetsAndSave();
      if (save) {
        const { shipIndex } = netsInfo;
        const { connector } = this.props;
        const { netShip } = connector;
        netShip[shipIndex].nets = nets;
        // const { nets } = checkConnectCompsPinsAndNets({ name: basicComp, designId: basicDesignId, nets: record[name] }, { designId, name: comp });

        this.saveConnectorInfo('netShip', netShip);
      }
    }
  }

  removeRelationShip = (e, index) => {
    e && e.stopPropagation()
    const { connector: { netShip = [] } } = this.props;
    let _netShip = [...netShip];
    const ship = _netShip[index];
    _netShip.splice(index, 1);
    this.saveConnectorInfo('netShip', _netShip);
    if (ship.designId && ship.connector) {
      this.props.deleteShip(ship, this.props.connector, true);
    }
  }

  getTabTitle = (ship, index) => {
    const { connector, designId } = ship;

    if (!connector || !designId) {
      return `Tab ${index + 1}`
    }
    const { pcbList } = this.props;
    const pcb = pcbList.find(item => item.id === designId);
    if (!pcb) {
      return `Tab ${index + 1}`
    }

    return `${pcb.name} - ${connector}`
  }

  changeTab = (tab) => {
    this.setState({
      activeKey: tab
    }, () => {
      setTimeout(() => {
        this.netsRef && this.netsRef.removeAllLines()
        this.props.resize()
      }, 100)
    })
  }

  onEdit = (tab) => {
    this.removeRelationShip(null, tab);
    const { activeKey } = this.state;
    if (tab === activeKey) {
      const _tab = Number(tab) - 1 > -1 ? Number(tab) - 1 : 0
      this.setState({
        activeKey: String(_tab)
      }, () => {
        setTimeout(() => {
          this.netsRef && this.netsRef.removeAllLines()
          this.props.resize()
        }, 100)
      })
    }
  }

  onNetsRef = (ref) => {
    this.netsRef = ref;
  }

  getNetsInfo = (ship, index) => {
    const { connector, designId: pcbId, nets } = ship;
    const { connector: _connector } = this.props;
    const { name, designId } = _connector;
    if (!designId || !name) {
      return { next: {}, prev: {}, nets, shipIndex: index };
    }
    const prevCompInfo = getCascadeComponents({ pcbId: designId, name })
    const next = {
      comp: name,
      name,
      compInfo: prevCompInfo,
      index: 1,
      type: 'next',
      pcb: designId,
      pcbKey: 'next'
    }
    const nextCompInfo = getCascadeComponents({ pcbId, name: connector })
    const prev = {
      comp: connector,
      name: connector,
      compInfo: nextCompInfo,
      index: 0,
      type: 'prev',
      pcb: pcbId,
      pcbKey: 'prev'
    }
    return { nets, next, prev, shipIndex: index }
  }

  couldSetInterposerOrPassive = (designId) => {
    const { designIds, pcbList } = this.props;
    if (pcbList.find(pcb => pcb.id === designId) && !designIds.includes(designId)) {
      return true;
    }
    return false;
  }

  shipRender = (ship, index) => {
    const { connector, designId, asInterposer = false, asPassiveBoard = false } = ship;
    const { pcbList } = this.props;
    const { connectorList } = this.state;
    const connectors = connectorList[designId] || [];
    const setInterposerOrPassive = this.couldSetInterposerOrPassive(designId);
    return <Fragment>
      <div className="cascade-conn-ship-content">
        <div className="add-connection-content">
          <span className="font-bold cascade-setup-title-color-only">PCB</span>
          <Select
            value={designId}
            className={`add-connection-item ${setInterposerOrPassive ? `set-interposer` : ''}`}
            onChange={(value) => this.PCBSelect(value, index)}
            getPopupContainer={(() => document.getElementById('root'))}
            showSearch={true}
            popupClassName="aurora-select-dropdown"
            options={pcbList.map(option => ({
              value: option.id,
              label: option.name,
              title: option.name
            }))}
          />
          {
            setInterposerOrPassive ? <div className="cascade-set-interposer-layout" style={{ right: 13 }}>
              <Checkbox checked={asInterposer} onChange={e => this.setInterposer(e, index)} >Set as Interposer</Checkbox>
              <Checkbox checked={asPassiveBoard} onChange={e => this.setPassiveBoard(e, index)} >Set as Passive Board</Checkbox>
            </div> : null
          }
        </div>
        <div className="add-connection-content">
          <span className="font-bold cascade-setup-title-color-only">Connector</span>
          <Select
            value={connector}
            className="add-connection-item"
            onChange={(value) => this.connectorSelect(value, index)}
            getPopupContainer={(() => document.getElementById('root'))}
            showSearch={true}
            popupClassName="aurora-select-dropdown"
            options={connectors.map(option => ({
              value: option.name,
              label: option.name,
              title: option.name
            }))}
          />
        </div>
      </div>
    </Fragment>
  }

  hasPassive = () => {
    const { activeKey } = this.state;
    const { connector, designTypes } = this.props;
    const { netShip } = connector;
    const ship = netShip[activeKey] || {};
    const { designId, asPassiveBoard } = ship;
    const isPassive = designTypes.find(item => item.designId === designId) ? designTypes.find(item => item.designId === designId).asPassiveBoard === true : false
    return isPassive || asPassiveBoard || this.props.asPassiveBoard
  }

  netConnectionRender = () => {
    const { activeKey, autoConnection } = this.state;
    const { contentWidth, contentHeight, drawStatus, connector, designTypes } = this.props;
    const { netShip } = connector;
    const ship = netShip[activeKey];
    if (!ship) {
      return null;
    }
    const { nets, asInterposer, designId, asPassiveBoard } = ship;
    const netsInfo = this.getNetsInfo(ship, activeKey);
    const isInterposer = designTypes.find(item => item.designId === designId) ? designTypes.find(item => item.designId === designId).type === IMPEDANCE_INTERPOSER_LAYOUT : false
    const isPassive = designTypes.find(item => item.designId === designId) ? designTypes.find(item => item.designId === designId).asPassiveBoard === true : false
    return <div className="cascade-position-relative">
      <NetsConnection
        nets={nets.flat(2)}
        netsInfo={netsInfo}
        contentWidth={contentWidth}
        contentHeight={contentHeight}
        onRef={this.onNetsRef}
        drawStatus={drawStatus}
        saveNets={this.saveNets}
        autoConnection={autoConnection}
        resize={this.props.resize}
        hasInterposer={isInterposer || asInterposer || this.props.asInterposer}
        hasPassive={isPassive || asPassiveBoard || this.props.asPassiveBoard}
      />
    </div>
  }

  render() {
    const { connector, index, connComps, disabledName } = this.props;
    const { activeKey } = this.state;
    const { name, netShip } = connector;
    const items = netShip.map((ship, index) => ({ key: String(index), label: this.getTabTitle(ship, index), closable: true, children: this.shipRender(ship, index) }))
    return (
      <div className="cascade-imp-add-connection">
        <div className="add-connection-content">
          <span className="font-bold cascade-setup-title-color-only">Connector Name</span>
          <Select
            value={name}
            className="add-connection-item"
            onChange={(value) => this.saveName('name', value)}
            getPopupContainer={(() => document.getElementById('root'))}
            showSearch={true}
            popupClassName="aurora-select-dropdown"
            disabled={disabledName}
            options={
              connComps.map(item => ({
                value: item.name,
                label: item.name
              }))
            }
          />
        </div>
        <div className="add-connection-relationship">
          <span className="font-bold cascade-setup-title-color-only">Connected to <PlusCircleOutlined
            className='cascade-imp-icon'
            onClick={() => this.props.addConnectorShip(index, name)} /></span>
        </div>
        <Tabs
          activeKey={String(activeKey)}
          className="add-connection-tab"
          onChange={this.changeTab}
          type="editable-card"
          onEdit={this.onEdit}
          hideAdd={true}
          items={items}
        />
        {this.netConnectionRender()}
      </div>
    );
  }
}

export default AddConnection;